(ns teamoesterreich.admin-mode.event.detail.event-overview
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [goog.json :as json]
            [clojure.string :as str]
            [teamoesterreich.util.log :as log]

            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.event :as d-events]

            [teamoesterreich.admin-mode.event.detail.event-stepper :as event-stepper]

            [teamoesterreich.admin-mode.event.task.event-task-list :as event-task-list]
            [teamoesterreich.admin-mode.event.detail.event-detail-form :as event-detail-form]
            [teamoesterreich.admin-mode.event.detail.event-member-selector :as event-member-selection]
            [teamoesterreich.admin-mode.event.detail.event-user-table :as event-user-table]
            [teamoesterreich.admin-mode.event.detail.event-admin :as event-admin]
            [teamoesterreich.admin-mode.event.detail.event-history :as event-history]

            ))



(defn get-tab-content []
  (let [!event (r/cursor vstate/app-state [:selected-event])
        !actual-user (r/cursor vstate/app-state [:actual-user])
        !tab (r/cursor vstate/app-state [:event-tab])
        !event-detail-loaded? (r/cursor vstate/app-state [:event-detail-loaded])
        event-status (or (:crowdtaskerEvent-status @!event) "created")
        event-step (case event-status
                     "created" 0
                     "waitAccept" 1
                     "collecting" 2
                     "running" 3
                     "finished" 4
                     "closed" 4
                     0)
        ro? (> event-step 3)
        ok? (and (> event-step 1) (< event-step 4))
        table-set-base {:ro? ro?}
        cnt-responseStatus-fn (fn [status] (count (filter (fn [e] (and (= "undefined" (or (:crowdtaskerEventMember-missionState e) "undefined"))
                                                                       (= status (or (:crowdtaskerEventMember-responseState e)
                                                                                     (if (:crowdtaskerEventMember-alarmedType e) "alarmed" "undefined"))))) (:crowdtaskerEvent-member @!event))))
        cnt-missionStatus-fn (fn [status] (count (filter (fn [e] (= status (or (:crowdtaskerEventMember-missionState e) "undefined"))) (:crowdtaskerEvent-member @!event))))
        ]
    [mui/card {}
     [mui/card-content {}
      (log/debug "Open Tab " @!tab)
      [mui/tabs {:value          @!tab
                 :onChange       (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                 :indicatorColor "primary"
                 :textColor      "primary"
                 :variant        "scrollable"
                 }
       [mui/tab {:value 0 :label "Details"}]
       [mui/tab {:value 82 :label "Crowdtasker"}]

       ; creating / isWaiting
       (when false [mui/tab {:value 20 :label (str "Geofence")}])
       (when true [mui/tab {:value 21 :label (str "Teilnahmekriterien")}])
       ; creating / isWaiting
       (when true [mui/tab {:value 2 :label (str "Manuell Zugeteilt (" (cnt-responseStatus-fn "undefined") ")")}])

       ;collecting  2
       (when (> event-step 1) [mui/tab {:value 3 :label (str "Angefragt (" (cnt-responseStatus-fn "alarmed") ")")}])
       (when (> event-step 1) [mui/tab {:value 5 :label (str "Absagen (" (cnt-responseStatus-fn "declined") ")")}])
       (when (> event-step 1) [mui/tab {:value 6 :label (str "Unklar (" (cnt-responseStatus-fn "invalid") ")")}])
       (when (> event-step 1) [mui/tab {:value 4 :label (str "Zusagen (" (cnt-responseStatus-fn "accepted") ")")}])

       ;running 3
       (when (>= event-step 3) [mui/tab {:value 7 :label (str "Reserve (" (cnt-missionStatus-fn "standby") ")")}])
       (when (>= event-step 3) [mui/tab {:value 9 :label (str "Nicht erschienen (" (cnt-missionStatus-fn "absent") ")")}])
       (when (>= event-step 3) [mui/tab {:value 8 :label (str "Im Einsatz (" (cnt-missionStatus-fn "participated") ")")}])


       (when true [mui/tab {:value 91 :label (str "Checkin")}])
       (when true [mui/tab {:value 92 :label (str "Verlauf")}])

       (when (or (= (:tom-id @!actual-user) 1) (= (:tom-id @!actual-user) 53177)) [mui/tab {:value 99 :label (str "RAW für " (:tom-id @!actual-user))}])
       ]
      ;[allow-unknown? allow-accepted? allow-rejected? allow-participated? allow-absent? allow-standby? allow-alarm? allow-force-alarm? allow-remove?]
      (case (or @!tab 0)
        0 [event-detail-form/get-it !event !event-detail-loaded? (not= event-status "created")]
        1 [event-detail-form/get-it !event !event-detail-loaded? (not= event-status "created")]

        82 [mui/card-content {}
            [(event-task-list/get-it !event)]]

        2 [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "undefined" nil (merge table-set-base {:allow-alarm? true :allow-accepted? true :allow-rejected? true :allow-remove? true}))]
        20 [event-member-selection/get-geofence (not= event-status "created")]
        21 [event-member-selection/get-it (not= event-status "created")]
        3 [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "alarmed" nil (merge table-set-base {:allow-force-alarm? true :allow-accepted? true :allow-rejected? true}))]
        5 [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "declined" nil (merge table-set-base {:allow-remove? true :allow-accepted? true :show-alarm-answer? true}))]
        6 [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "invalid" "undefined" (merge table-set-base {:allow-accepted? true :allow-rejected? true :show-alarm-answer? true}))]
        4 [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "accepted" "undefined" (merge table-set-base {:allow-rejected?     true :allow-standby? (>= event-step 3)
                                                                                                                     :allow-participated? (>= event-step 3) :allow-absent? (>= event-step 3)
                                                                                                                     :allow-change-slot?  true :show-alarm-answer? true}))]
        7 [(event-user-table/get-it (:crowdtaskerEvent-member @!event) nil "standby" (merge table-set-base {:allow-change-slot? true :allow-unknown? true :allow-participated? true :allow-absent? true}))]
        8 [(event-user-table/get-it (:crowdtaskerEvent-member @!event) nil "participated" (merge table-set-base {:allow-change-slot? true :allow-unknown? true :allow-standby? true :allow-absent? true}))]
        9 [(event-user-table/get-it (:crowdtaskerEvent-member @!event) nil "absent" (merge table-set-base {:allow-change-slot? true :allow-unknown? true :allow-standby? true :allow-participated? true}))]

        91 [event-admin/get-it]
        92 [event-history/get-it]
        99 [:p "Übersicht über Events....." [:pre {:style {:textAlign "left"}} (str/replace (json/serialize (clj->js @!event)) "," ",\n")]]

        [:p "or else " @!tab]
        )

      ]]))



(defn get-it []
  (let [!event (r/cursor vstate/app-state [:selected-event])
        !eventUuid (r/cursor vstate/app-state [:path :entityId])
        !event-detail-loaded? (r/cursor vstate/app-state [:event-detail-loaded])
        ]

    (println "Actual event " @!event-detail-loaded? "\n" @!eventUuid)
    (when (nil? @!eventUuid)
      (a/set-page :event-list))

    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "flex-start"
      :alignItems "flex-start"
      :spacing    1
      }
     (when (or (not @!event-detail-loaded?) (not= @!eventUuid (:crowdtaskerEvent-uuid @!event)))
       (d-events/<event-load @!eventUuid
                             (fn [response]
                               (reset! !event response)
                               (reset! !event-detail-loaded? true)
                               ))
       [mui/grid
        {:container false :item true
         :md        12                                      ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         :style     {:marginTop "5px"}
         }
        [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
        [mui/typography {} "Lade Daten ... "]
        ])
     (when @!event-detail-loaded?
       [mui/grid
        {:container false :item true
         :md        12                                      ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         :style     {:marginTop "5px"}
         }
        [event-stepper/get-it]
        ])
     (when @!event-detail-loaded?
       [mui/grid
        {:container false :item true
         :md        12                                      ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         :style     {:marginTop "5px"}
         }
        [get-tab-content]
        ])

     ]

    ))
















